export default {
  saveSearchUserAction(context, payload) {
    context.commit('searchUserCommit', payload);
  },
}
